<template>
  <div v-if="applicable.length > 1" class="apply-all">
    <b-button
      size="is-small"
      type="is-primary"
      :loading="applying"
      :disabled="disabled || !!busyAction"
      @click="$emit('apply-all', applicable)"
      >{{
        $t('chat_box.action_apply_all', { count: applicable.length })
      }}</b-button
    >
  </div>
</template>

<script>
// Apply all for one answer's proposed DIJ changes: the agent applies them in
// card order and stops at the first that is not applied.
import { isApplicable } from '../actionState';

export default {
  props: {
    actions: {
      type: Array,
      required: true,
    },
    // { actionIds, decision, all } of the click in flight.
    busyAction: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { now: Date.now() };
  },
  computed: {
    // The changes that can still be applied, in card order.
    applicable() {
      return this.actions.filter((action) => isApplicable(action, this.now));
    },
    applying() {
      const busy = this.busyAction;
      return (
        !!busy &&
        busy.all &&
        this.actions.some((action) => busy.actionIds.includes(action.actionId))
      );
    },
  },
  mounted() {
    // Cards expire on their own. The clock lives here, not in the chat body,
    // whose updates scroll the chat to the bottom.
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.apply-all {
  margin: 0 0 10px 46px;
}
</style>
